import Box from '@mui/material/Box';
import { teal } from '@mui/material/colors';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Notification from 'interfaces/Notification';
import { convertIsoToLocaleString } from 'utils/grid';
import '../stylesheets/NotificationDetails.scss';

const columns: GridColDef[] = [
    {
        field: 'StateOfLicense',
        headerName: 'State Of License',
        headerClassName: 'expiring-license-grid-header',
        flex: 1,
    },
    {
        field: 'LicEndDt',
        headerName: 'Expiration Date',
        valueGetter: ({ row }) => convertIsoToLocaleString(row['LicEndDt']),
        headerClassName: 'expiring-license-grid-header',
        flex: 1,
    },
];

type ExpiringLicensesProps = {
    notification: Notification;
};

const ExpiringLicenses = ({ notification }: ExpiringLicensesProps) => {
    const expiringLicenses = notification.actionMetadata?.[
        'ExpiringLicenses'
    ]?.map((expiringLicense) => ({
        ...expiringLicense,
        id: expiringLicense['StateOfLicense'],
    }));

    return (
        <div id="notification-details-content">
            <p>
                You have licenses that will expire soon. To avoid any
                disruptions, please ensure you complete your renewal process
                before these date(s).
            </p>
            <Box
                padding={3}
                sx={{
                    width: '100%',
                    '& .expiring-license-grid-header': {
                        backgroundColor: teal[50],
                    },
                }}
            >
                <DataGrid
                    rows={expiringLicenses}
                    columns={columns}
                    hideFooter
                    disableRowSelectionOnClick={true}
                    sx={{
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: 'transparent',
                        },
                        '& .MuiDataGrid-row.Mui-hovered': {
                            backgroundColor: 'transparent',
                        },
                    }}
                />
            </Box>
        </div>
    );
};

export default ExpiringLicenses;
